import { Toaster } from "react-hot-toast";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Login from "./Pages/Login";
import { useAuthStore } from "./Zustand/AuthStore";
import RolesManage from "./Pages/RolesManage/RolesManage";
import RoleAdd from "./Pages/RolesManage/RoleAdd";
import RoleEdit from "./Pages/RolesManage/RoleEdit";
import RoleView from "./Pages/RolesManage/RoleView";
import ModuleUnifiedForm from "./Pages/ModuleMaster/ModuleUnifiedForm";
import ModuleMaster from "./Pages/ModuleMaster/Module";
import PageMaster from "./Pages/PageMaster/Page";
import PageUnifiedForm from "./Pages/PageMaster/PageUnifiedForm";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import Users from "./Pages/UsersMaster/Users";
import UserUnifiedForm from "./Pages/UsersMaster/UserUnifiedForm";
import StatusUnifiedForm from "./Pages/StatusMaster/StatusUnifiedForm";
import Status from "./Pages/StatusMaster/Status";
import Course from "./Pages/CourseMaster/Course";
import CourseUnifiedForm from "./Pages/CourseMaster/CourseUnifiedForm";
import Editor from "./Pages/WYSWYG/Editor";
import LatestNotifications from "./Pages/Latest-Notifications/LatestNotifications";
import { LatestNotificationUnifiedForn } from "./Pages/Latest-Notifications/LatestNotificationUnifiedForn";
import Metamaster from "./Pages/MetaMaster/Metamaster";
import CreateMeta from "./Pages/MetaMaster/CreateMeta";
import MetaEdit from "./Pages/MetaMaster/MetaEdit";
import MetaView from "./Pages/MetaMaster/MetaView";

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <ThemeProvider theme={theme}>
      <Toaster />
      <Routes>
        <Route
          path="/"
          element={isAuthenticated ? <Navigate to="/home" /> : <Login />}
        />
        {/* <Route path="/" element={<Login />} /> */}
        {isAuthenticated && (
          <>
            <Route path="/home" element={<Home />} />
            <>
              <Route path="/roles/manage" element={<RolesManage />} />
              <Route path="/roles/add" element={<RoleAdd />} />
              <Route path="/roles/edit/:id" element={<RoleEdit />} />
              <Route path="/roles/view/:id" element={<RoleView />} />
            </>
            <>
              <>
                <Route path="/modules/manage" element={<ModuleMaster />} />
                <Route
                  path="/modules/manage/form/:mode/:id?"
                  element={<ModuleUnifiedForm />}
                />
              </>
              <>
                <Route path="/pages/manage" element={<PageMaster />} />
                <Route
                  path="/pages/manage/form/:mode/:id?"
                  element={<PageUnifiedForm />}
                />
              </>
              <>
                <Route path="/user/manage" element={<Users />} />
                <Route
                  path="/user/manage/form/:mode/:id?"
                  element={<UserUnifiedForm />}
                />
              </>
              <>
                <Route path="/status/manage" element={<Status />} />
                <Route
                  path="/status/manage/form/:mode/:id?"
                  element={<StatusUnifiedForm />}
                />
              </>
              <>
                <Route path="/courses/manage" element={<Course />} />
                <Route
                  path="/courses/manage/form/:mode/:id?"
                  element={<CourseUnifiedForm />}
                />
              </>
              <>
                <Route path="/web/wysiwyg/manage" element={<Editor />} />
              </>
              <>
                <Route
                  path="/web/latest-notifications/manage"
                  element={<LatestNotifications />}
                />
                <Route
                  path="/web/latest-notifications/manage/form/:mode/:id?"
                  element={<LatestNotificationUnifiedForn />}
                />
                <>
                  <Route
                    path="/web/meta-tags/manage"
                    element={<Metamaster />}
                  />
                  <Route
                    path="/web/meta-tags/form/create"
                    element={<CreateMeta />}
                  />
                  <Route
                    path="/web/meta-tags/form/edit/:id"
                    element={<MetaEdit />}
                  />
                  <Route
                    path="/web/meta-tags/form/view/:id"
                    element={<MetaView />}
                  />
                </>
              </>
            </>
          </>
        )}
      </Routes>
    </ThemeProvider>
  );
}

export default App;
